import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { NOME_MARCA } from '../../../../environments/environment';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { RmpvPecaMensalService } from './service/rmpv-peca-mensal.service';
import { TotalizadorGrafico } from './totalizador-grafico';

declare var $: any;

@Component({
  selector: 'app-rmpv-peca-mensal',
  templateUrl: './rmpv-peca-mensal.component.html',
  styleUrls: ['./rmpv-peca-mensal.component.css']
})
export class RmpvPecaMensalComponent extends ListaBase implements OnInit {

  objTranslateAPI = {
    "Cliente": "rmpv.peca.cliente",
    "Garantia": "rmpv.peca.garantia",
    "Funilaria e Pintura": "rmpv.peca.funilariaPintura",
    "Acessório": "rmpv.peca.acessorio",
    "Retorno": "rmpv.peca.retorno",
    "Recall": "rmpv.peca.recall",
    "Motos usadas": "rmpv.peca.motosUsada",
    "Outras Internas": "rmpv.peca.outraInterna",
    "Cortesia": "rmpv.peca.cortesia",
    "Revisão": "rmpv.peca.revisao",
    "Seguro/Franquia": "rmpv.peca.seguroFranquia",
    "Outras": "rmpv.peca.outra",
    "PDI": "rmpv.peca.pdi",
    "Venda balcão": "rmpv.peca.vendaBalcao",
    "Valor Devolução": "rmpv.peca.valorDevolucao"

  };

  arrayTranslateChart = [{ categoria: "Cliente", chave: "rmpv.peca.cliente" },
  { categoria: "Garantia", chave: "rmpv.peca.garantia" },
  { categoria: "Funilaria e Pintura", chave: "rmpv.peca.funilariaPintura" },
  { categoria: "Acessório", chave: "rmpv.peca.acessorio" },
  { categoria: "Motos usadas", chave: "rmpv.peca.motosUsada" },
  { categoria: "Outras Internas", chave: "rmpv.peca.outraInterna" },
  { categoria: "Cortesia", chave: "rmpv.peca.cortesia"},
  { categoria: "Revisão", chave: "rmpv.peca.revisao"},
  { categoria: "Seguro/Franquia", chave: "rmpv.peca.seguroFranquia"},
  { categoria: "Outras", chave: "rmpv.peca.outra" },
  { categoria: "Retorno", chave: "rmpv.peca.retorno" },
  { categoria: "Recall", chave: "rmpv.peca.recall" },
  { categoria: "PDI", chave: "rmpv.peca.pdi" },
  { categoria: "Venda balcão", chave: "rmpv.peca.vendaBalcao" },
  { categoria: "Valor Devolução", chave: "rmpv.peca.valorDevolucao" }
  ];

  carregando = false;
  categorias: string[] = [];
  totalGeral: any;
  marca = NOME_MARCA
  subscription;

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: { display: true },
  };

  public barChartLabels: string[] = [];
  public barChartLabelsCache: string[] = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData: any[] = [];
  public barChartColors: any[] = [];

  parametrosFiltro: any;
  valoresMarcasOriginal;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  PrimeiraMarcaLabel = '';
  SegundaMarcaLabel = '';
  PrimeiraMarca: boolean = true;
  SegundaMarca: boolean = true;

  constructor(service: RmpvPecaMensalService,
    toast: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toast, router);
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['data_inicial'], params['data_final']);
      this.carregarFiltrosParametros();
    });

    this.getTranslateChart();

  }

  ngOnInit() {
    this.buscar();
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewChecked() {
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const firstData = new Date();
      this.InicialData = firstData.getFullYear() + '-' + ('0' + (firstData.getMonth() + 1)).slice(-2) + '-' + '01';
    } else {
      const now = new Date(dataInicial);
      this.InicialData = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + (now.getUTCDate())).slice(-2);
    }

    if (dataFinal === undefined || dataFinal.toString() === '') {
      const lastData = new Date();
      this.FinalData = lastData.getFullYear() + '-' + ('0' + (lastData.getMonth() + 1)).slice(-2) + '-' + lastData.getUTCDate();
    } else {
      const now = new Date(dataFinal);
      this.FinalData = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + (now.getUTCDate())).slice(-2);
    }

    this.filtros = { data_inicial: this.InicialData, data_final: this.FinalData };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getDados(res: any): any {
    if (res.meses.length === 0) {
      return res.meses;
    }

    res.meses.forEach(res => {
      res.marcas.total = this.conversaoLibraConverte.conversaoLibra(res.marcas.total, null, null);
      res.marcas[0].dados.forEach(res => {
        res.original = this.conversaoLibraConverte.conversaoLibra(res.original, null, null);
        res.paralelo = this.conversaoLibraConverte.conversaoLibra(res.paralelo, null, null);
        res.lubrificante = this.conversaoLibraConverte.conversaoLibra(res.lubrificante, null, null);
        res.pneu = this.conversaoLibraConverte.conversaoLibra(res.pneu, null, null);
      });
    });

    this.totalGeral = {};
    this.totalGeral.marcas = [];

    this.carregarTipos(res.meses[0].marcas[0]);

    this.calcularTotaisMensais(res);

    this.calcularTotalGeral();

    this.carregando = false;

    return res.meses;
  }

  private calcularTotalGeral() {
    let total = this.criarTotalizador(this.totalGeral.marcas[0], 'Total', 0);
    this.totalGeral.marcas.forEach(marca => {
      marca.original = this.conversaoLibraConverte.conversaoLibra(marca.original, null, null);
      marca.paralelo = this.conversaoLibraConverte.conversaoLibra(marca.paralelo, null, null);
      marca.lubrificante = this.conversaoLibraConverte.conversaoLibra(marca.lubrificante, null, null);
      marca.pneu = this.conversaoLibraConverte.conversaoLibra(marca.pneu, null, null);
      this.totalizarCategorias(marca);
      this.totalizarMarcas(marca, total);
    });

    this.carregarGraficos(this.totalGeral.marcas);
  }

  private calcularTotaisMensais(res: any) {
    res.meses.forEach(mes => {
      mes.marcas.forEach(marca => {
        marca.dados.forEach(element => {
          element['faturamento'] = element.original + element.paralelo + element.lubrificante + element.pneu;
        });
      });

      const totalMes = this.criarTotalizador(res.meses[0].marcas[0], 'Total', 0);
      this.totalizarPorMes(mes, totalMes);
    });
  }

  private totalizarPorMes(mes: any, totalMes: any) {
    mes.marcas.forEach(marca => {
      this.totalizarCategorias(marca);
      this.somarTotalGeralPorMarca(marca);
      this.totalizarMarcas(marca, totalMes);
    });

    this.totalizarCategorias(totalMes);
  }

  carregarGraficos(lista: any[]) {
    const grafico = new TotalizadorGrafico();

    grafico.processar(lista);

    if (this.marca.includes("Triumph") || this.marca.includes("Harley")) {
    // if (this.marca === 'Triumph' || this.marca === "Harley") {
      if (this.translate.currentLang == 'br') {
        this.barChartLabels = grafico.getLabels();
      } else {
        this.barChartLabels = ["Client", "Guarantee", "Auto body and Paint", "Accessory", "PDI", "Return", "Recall", "Used motorcycles", "Other Interns", "Courtesy", "Other", "Sale counter", "Return Value"];
      }
    } else if (this.marca.includes("Volvo") || this.marca.includes("Porsche") ||  this.marca.includes("Stuttgart") || this.marca.includes("GWM") || this.marca.includes("BYD") || this.marca.includes("NBS")) {
    // } else if (this.marca === 'Volvo') {
      if (this.translate.currentLang == 'br') {
        this.barChartLabels = grafico.getLabels();
      } else {
        this.barChartLabels = ["Client", "Guarantee", "Auto body and Paint", "Accessory", "PDI", "Return", "Recall", "Used cars", "Other Interns", "Courtesy", "Revision", "Insurance/Deductible", "Other"];
      }
    }
    this.barChartType = grafico.getTipo();
    this.barChartLegend = grafico.getLegenda();
    this.barChartData = grafico.getDados();
    this.barChartColors = grafico.getColors();
  }

  //************** Sublinha o label da marca no grafico quando o item fica desativado************* */
  toogleLabelJaguar() {
    $('.fontJaguar').toggleClass('active');
  }

  toogleLabelLandRover() {
    $('.fontLandRover').toggleClass('active');
  }

  /*************************************************************************************************/

  totalizarMarcas(marca: any, total: any) {
    marca.dados.forEach(element => {
      const index = total.dados.findIndex((item) => element.id === item.id);
      total.dados[index].faturamento += element.faturamento;
    });
  }

  criarTotalizador(objeto: any, descricao: string, id: number): any {

    const total: any = {};
    total.dados = [];

    objeto.dados.forEach(element => {
      const categoria: any = {};

      for (const chave in element) {
        if (element.hasOwnProperty(chave)) {
          categoria[chave] = element[chave];
        }
      }
      categoria.faturamento = 0;
      total.dados.push(categoria);
    });

    total.id = id;
    total.marca = descricao;

    return total;
  }

  somarTotalGeralPorMarca(marca: any) {

    let item: any;

    const index = this.totalGeral.marcas.findIndex((p) => marca.id === p.id);

    if (index < 0) {
      item = this.criarTotalizador(marca, marca.marca, marca.id);
      this.totalGeral.marcas.push(item);
    } else {
      item = this.totalGeral.marcas[index];
    }

    item.dados.forEach(element => {
      const posicao = marca.dados.findIndex((c) => c.id === element.id);

      element.faturamento += marca.dados[posicao].faturamento;
    });
  }

  carregarTipos(marca: any): any {
    this.categorias = [];
    marca.dados.forEach(element => {
      this.categorias.push(element.nome);
    });
  }

  totalizarCategorias(marca: any) {
    let total = 0;
    let internas = 0;

    marca.dados.forEach(categoria => {
      total += categoria.faturamento;
      internas += categoria.interna ? categoria.faturamento : 0;
    });

    marca.total = total;
    marca.internas = internas;
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  public definirFiltragem() {
    $('#rmpv-peca-mensal-filtro').modal();
  }


  voltar() {
    this.router.navigateByUrl(this.obterUrlComFiltros());
  }

  obterUrlComFiltros(): string {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    return 'rmpv/peca' + url;
  }

  getTranslate(value) {
    if (value == 'Motos usadas') {
      return value = this.translate.currentLang == 'br' ? 'Motos usadas' : 'Used motorcycles';
    } else if (value == 'Carros usados') {
      return value = this.translate.currentLang == 'br' ? 'Carros usados' : 'Used cars';
    }
    return this.objTranslateAPI[value];
  }

  getTranslateChart() {
    if (!this.dados) {
      return;
    }

    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {

        let labelsTranslateChart;
        if (!this.barChartLabelsCache.length) {
          this.barChartLabelsCache = Array.from(this.barChartLabels);
        }

        this.translate
          .stream(this.arrayTranslateChart.map(item => item.chave))
          .subscribe(value => {

            labelsTranslateChart = [];
            this.barChartLabelsCache.forEach(element => {

              this.arrayTranslateChart.forEach(item => {
                if (element === item.categoria) {
                  labelsTranslateChart.push(value[item.chave]);
                }
              });

            });
            this.barChartLabels = Array.from(labelsTranslateChart);

          }, error => console.log(error));
      });
  }

}
